import React, { useEffect, useState, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { MultiStepForm } from './components/MultiStepForm';
import { StickyContact } from './components/UI/StickyContact';
import { Testimonials } from './components/UI/Testimonials';
import { MinimalHeader } from './components/Layout/MinimalHeader';
import { MinimalFooter } from './components/Layout/MinimalFooter';
import { CompanyValueProps } from './components/UI/CompanyValueProps';
import { SuccessPage } from './components/Layout/SuccessPage';
import { initFacebookPixel, MetaPixelNoScript, debugPixelStatus } from './src/utils/FacebookPixel';
import { initGoogleAnalytics } from './src/utils/GoogleAnalytics';
import { useFacebookPixel } from './src/utils/useFacebookPixel';
// Enhanced route tracker that handles both Facebook Pixel and other analytics
const RouteTracker = () => {
  // Use our custom hook for Facebook Pixel tracking
  useFacebookPixel();
  // Get current location for logging
  const location = useLocation();
  // Log route changes for debugging
  useEffect(() => {
    console.log('Route changed to:', location.pathname);
  }, [location]);
  return null;
};
// Immediate pixel initialization before app renders
export function App() {
  // Initialize tracking as early as possible but only once
  useEffect(() => {
    console.log('App mounted - initializing Google Analytics');
    // Only initialize Google Analytics here, Facebook Pixel is already initialized in index.tsx
    initGoogleAnalytics();
    // Debug pixel status after app mount
    setTimeout(() => {
      const status = debugPixelStatus();
      console.log('Pixel status check after app mount:', status);
    }, 1000);
    // Load font
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="bg-[#F0F0F0] min-h-screen w-full font-[Montserrat] flex flex-col" data-id="element-1">
        {/* Place Meta Pixel NoScript at the top of the body */}
        <MetaPixelNoScript data-id="element-2" />
        {/* Use enhanced route tracker */}
        <RouteTracker data-id="element-3" />
        <MinimalHeader data-id="element-4" />
        <main className="flex-grow" data-id="element-5">
          <div className="max-w-[900px] mx-auto px-4 py-8 md:py-12" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<>
                    <div className="mb-8 md:mb-12 text-center" data-id="element-9">
                      <h1 className="text-2xl md:text-3xl font-bold text-[#111010] mb-3" data-id="element-10">
                        Offerte aanvragen
                      </h1>
                      <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-11">
                        Vul het formulier in en ontvang binnen 48 uur een
                        vrijblijvende offerte voor uw project. Wij helpen u
                        graag verder met een transparante en scherpe prijs.
                      </p>
                    </div>
                    <MultiStepForm data-id="element-12" />
                    <CompanyValueProps data-id="element-13" />
                    <Testimonials data-id="element-14" />
                  </>} data-id="element-8" />
              <Route path="/bedankt" element={<SuccessPage data-id="element-16" />} data-id="element-15" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-18" />} data-id="element-17" />
            </Routes>
          </div>
        </main>
        <MinimalFooter data-id="element-19" />
        <StickyContact phoneNumber="+31625387128" data-id="element-20" />
      </div>
    </BrowserRouter>;
}